<template>
  <div>
    <surveys-table
      surveyName="NAPSI-MM"
      surveyCode="NAPSIMM"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_NAPSIMM,
        viewDetail: permissions.SEE_DETAIL_SURVEY_NAPSIMM,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
